var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"z-1",class:_vm.activeInput ? 'active-input' : ''},[_c('functional-calendar',{staticClass:"test",attrs:{"configs":_vm.calendarConfigs},on:{"choseDay":_vm.dayClicked,"opened":function($event){_vm.activeInput = !_vm.activeInput},"closed":() => {
        _vm.callback();
        _vm.activeInput = false;
      }},model:{value:(_vm.calendarData),callback:function ($$v) {_vm.calendarData=$$v},expression:"calendarData"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }